import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Login } from '../components/login/login';
import { activateRA } from '../components/users/activateuser';
import { AuthModel } from '../components/authorize/auth-model';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    apiUrl = environment.apiUrl

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private http: HttpClient,private _authservice:AuthService) { }

    loginBBUser(login: Login): Observable<AuthModel> {
        return this.http.post<AuthModel>(this.apiUrl + "Login", login);
    }
    
    loginUsingAuthToken(login:Login):Observable<AuthModel>{
        return this.http.post<AuthModel>(this.apiUrl + "loginWithToken", login);
    }

    verifyTwoFactor(token: string, code: string, rememberMe: boolean): Observable<AuthModel> {
        return this.http.post<AuthModel>(this.apiUrl + "VerifyTwoFactor", { token, code, rememberMe });
    }

    resendTwoFactor(token: string): Observable<AuthModel> {
        return this.http.post<AuthModel>(this.apiUrl + "ResendTwoFactor", { token });
    }

    logoutUser():Observable<any>
    {
        const token = this._authservice.getAuthToken();
        let params = new HttpParams();
        params = params.append("token",token)
        this._authservice.logout();
        return this.http.put(this.apiUrl + "logoutUser",null,{params:params});
    }
    
}